// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__Mj7Jp","alertIcon":"ConfirmModal_alertIcon__TgLDI"};